<ion-app>
  <app-header></app-header>

  @if (navigationService.position() !== null) {
    <ion-content>
      @if (navigationService.position() === 'disabled') {
        <ng-template *ngTemplateOutlet="sidemenu">
        </ng-template>
        <ng-template *ngTemplateOutlet="content">
        </ng-template>
      }
      @if (navigationService.position() === 'left') {
        <ion-split-pane style="--side-max-width: 10%;" when="xs" contentId="main"
          >
          <ng-container *ngTemplateOutlet="sidemenu">
          </ng-container>
          <div id="main">
            <ng-template *ngTemplateOutlet="content"></ng-template>
          </div>
        </ion-split-pane>
      }
      @if (navigationService.position() === 'bottom') {
        <ng-container *ngTemplateOutlet="content">
        </ng-container>
        <ng-container *ngTemplateOutlet="sidemenu">
        </ng-container>
      }
    </ion-content>
  }

  <oe-navigation></oe-navigation>
  @if (latestIncident !== null) {
    <oe-notification color="warning" [text]="latestIncident.message"
      [id]="latestIncident.id">
    </oe-notification>
  }
  <ng-container *ngTemplateOutlet="footer"></ng-container>
</ion-app>

<ng-template #content>
  @if (websocket.status === 'connecting' || websocket.status === 'failed') {
    <ion-grid>
      <ion-row class="ion-justify-content-center">
        <ion-col size="12" size-md="6">
          <ion-card>
            @switch (websocket.status) {
              <!-- Trying to connect to backend -->
              @case ('connecting') {
                <ion-item color="light">
                  <ion-icon slot="start" name="wifi-outline"></ion-icon>
                  <ion-label class="ion-text-wrap">
                    <h2 translate>INDEX.CONNECTION_IN_PROGRESS</h2>
                  </ion-label>
                </ion-item>
              }
              <!-- Connection failed -->
              @case ('failed') {
                <ion-item color="light">
                  <ion-icon slot="start" name="close-circle-outline"></ion-icon>
                  <ion-label class="ion-text-wrap">
                    <h2 translate [translateParams]="{value: 'OpenEMS'}">INDEX.CONNECTION_FAILED</h2>
                    <p color="light">{{ environment.url }}</p>
                  </ion-label>
                </ion-item>
              }
            }
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

  @if (isSystemLogEnabled) {
    <systemLog></systemLog>
  }

  <!-- Show Sub-Views -->
  <ion-router-outlet id="content"></ion-router-outlet>
</ng-template>

<ng-template #sidemenu>
  <ion-menu menuId="main-menu" [contentId]="navigationService.position === 'left' ? 'main': 'content'"
    [type]="navigationService.position === 'left' ? '': 'overlay'" side="start">
    <ion-list>
      @if ((service.metadata | async)?.user; as user) {
        <ion-item tabindex="0" button routerLinkActive="active"
          (keydown.enter)="navCtrl.navigateRoot('/user');menu.close()"
          (click)="navCtrl.navigateRoot('/user');menu.close()">
          <ion-icon style="margin-right: 5%" size="large" color="primary" slot="start" name="person-outline">
          </ion-icon>
          <ion-label>
            <p style="color:var(--ion-text-color);">{{ user.name }}</p>
            <ion-text>
              <p style="color:var(--ion-text-color-shade);">{{ user.id }}</p>
            </ion-text>
          </ion-label>
        </ion-item>
      }

      <!-- Show Link to Overview if more than one Edge is accessible or the globalRole is at least installer -->
      @if ((service.metadata | async); as service) {
        @if (isUserAllowedToSeeOverview) {
          <ion-item lines="full" routerLinkActive="active" routerLink="/overview" (click)="menu.close()">
            <ion-label>{{"MENU.OVERVIEW" | translate}}</ion-label>
          </ion-item>
        }
      }

      @if (service.currentEdge(); as edge) {
        <nav>
          <ion-item lines="inset" routerLink="/device/{{ edge.id }}/settings" (click)="menu.close()">
            <ion-label>{{"MENU.EDGE_SETTINGS" | translate}}</ion-label>
          </ion-item>
        </nav>
      }

      @if(!service.isSmartphoneResolution && navigationService.position() === "left"){
        <oe-navigation-chips (navigate)="navigationService.navigateTo($event)"></oe-navigation-chips>
      }
    </ion-list>
  </ion-menu>
</ng-template>

<ng-template #footer>
  @if (isSystemOutage) {
    <ion-footer>
      <ion-toolbar color="warning">
        <ion-grid>
          <ion-row class="ion-justify-content-center">
            <ion-col size="12" size-md="6">
              <span translate>GENERAL.SYSTEM_OUTAGE</span>
              <span>&nbsp;</span>
              <a href="https://status.fenecon.de/" target="_blank">status.fenecon.de</a>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-toolbar>
    </ion-footer>
  }
  @if (isUserAllowedToSeeFooter && !isHistoryDetailView) {
    <oe-footer #appFooter slot="fixed"></oe-footer>
  }
</ng-template>
